export default "__VITE_ASSET__FBI$NckJ__"